module.exports = __webpack_public_path__ + "static/media/morion-regular.f2719916.woff";